import Resource from './Resource'
import { RESOURCE } from './constants'

class ResourceList {
    constructor( resources ) {
        this.resources = resources.map(resource => new Resource({...resource}))
    }

    get cost() {
        return this.resources.reduce((stack, resource) => {
            if (resource.amount < 0 ) {
                stack.push(new Resource({...resource}))
            }
            return stack
        }, [])
    }

    get earnings() {
        return this.resources.reduce((stack, resource) => {
            if (resource.amount > 0) {
                stack.push(new Resource({...resource}))
            }
            return stack
        }, [])
    }
    
    get(type) {
        const foundResource = this.resources.find(resource => resource.type === type)

        return foundResource || new Resource({ type: type, amount: 0})
    }

    map(callback) {
        return this.resources.map(callback)
    }

    compute( resources ) {
        const newResources = new ResourceList([
            new Resource({ type: RESOURCE.HEALTH, amount: this.get(RESOURCE.HEALTH).amount + resources.get(RESOURCE.HEALTH).amount }),
            new Resource({ type: RESOURCE.SANITY, amount: this.get(RESOURCE.SANITY).amount + resources.get(RESOURCE.SANITY).amount }),
            new Resource({ type: RESOURCE.SUPPLIES, amount: this.get(RESOURCE.SUPPLIES).amount + resources.get(RESOURCE.SUPPLIES).amount }),
            new Resource({ type: RESOURCE.FAME, amount: this.get(RESOURCE.FAME).amount + resources.get(RESOURCE.FAME).amount })
        ])

        return newResources
    }
    
}

export default ResourceList